export class SidebarPermissionsModel {
  projects = false;
  new_project = false;
  employees = false;
  clients = false;
  locations = false;
  agency_dashboard = false;
  agency_profile = false;
  agency_client = false;
  orders = false;
  create_order = false;
  view_staff = false;
  settings = false;
  work_validation_view = false;
  view_work_validation = false;
  payroll = false;
  supervisor_on_site = false;
  // JS-1802: client name shown on the client portal sidebar; null for agency users.
  client_name: string = null;
}
